
import React from "react";
import './dropdown.scss';
import { DropDownList } from "@progress/kendo-react-dropdowns";

// interface to declare all our prop types
export type Props =  {
    data?: any;
    defaultValue?:any;
    onChange?: any
    value?:  any
    defaultItem?:any;
    // handleChange?: any
    textField?: string
    dataItemKey?: string
    name?: string
  ref?: any
  disabled?: boolean;
   
}

const DropDownListselect: React.FC<Props> = ({
    data,
    onChange,
    defaultValue,
    name,
    defaultItem,
    value,
    ref,
    // id,
    textField,
  dataItemKey,
  disabled,
  ...rest
}) => {

  
  return (
    <div className="autodropdown">
        <DropDownList 
          // name={name}
          data={data}
          name={name}
          defaultValue={defaultValue} 
          value={value}
          defaultItem={defaultItem}
          // data={data}
          disabled={disabled}
          textField={textField}
          dataItemKey={dataItemKey}
          onChange={onChange}
          ref={null}
        />
    </div>
  );
};

export default DropDownListselect ;


